import apiHelperService from '@/services'
import { useFormStore } from '@/stores/form'
import use446Actions from '@/composables/actions/use446Actions'
import useFormatDate from '@/composables/useFormatDate'
import { DateTime } from 'luxon'
// find the max date and return that item.
const proccessTheDate = (currentTime) => {
  var mostRecentDate = new Date(
    Math.max.apply(
      null,
      currentTime.map((timeObj) => {
        return new Date(timeObj.key)
      })
    )
  )
  var mostRecentObject = currentTime.filter((timeObj) => {
    var tempTime = new Date(timeObj.key)
    return tempTime.getTime() == mostRecentDate.getTime()
  })[0]

  return mostRecentObject
}
const changeAppointmentDate = (newSelectDate) => {
  if (newSelectDate) {
    return
  }
  formStore.form.setFieldValue('selectedStartEndTimes', null)
  const formStore = useFormStore()
  const res = apiHelperService.post(
    '/api/appointments/get-available-booking-times',
    formStore.form.values
  )
  if (res && res.data && res.data.length > 0) {
    const mostRecentObject = proccessTheDate(res.data)
    formStore.form.setFieldValue('tempAppointmentMaxDate', new Date(mostRecentObject.key))
  }
}

const checkDateForViolationNumberOfYears = () => {
  const { formateDateFromDDMMYYYY } = useFormatDate()
  const formStore = useFormStore()
  const { violationStartDate = '', applicationDate = '' } = formStore.form.values
  if (!violationStartDate || !applicationDate) {
    return
  }
  let num =
    formateDateFromDDMMYYYY(applicationDate).toJSDate().getFullYear() -
    formateDateFromDDMMYYYY(violationStartDate).toJSDate().getFullYear()
  formStore.form.setFieldValue('violationNumberOfYears', num)
}
const getDayOfWeek = (date, { refs }) => {
  const formStore = useFormStore()

  try {
    const d = DateTime.fromFormat(date, 'dd/MM/yyyy')

    const englishRefs = refs.filter((r) => r.toLowerCase().includes('english'))
    if (englishRefs) {
      englishRefs.forEach((ref) => {
        formStore.form.setFieldValue(ref, d.toFormat('cccc'))
      })
    }

    const arabicRefs = refs.filter((r) => r.toLowerCase().includes('arabic'))
    if (arabicRefs) {
      arabicRefs.forEach((ref) => {
        formStore.form.setFieldValue(ref, d.setLocale('ar').toFormat('cccc'))
      })
    }
  } catch (error) {
    console.error('[getDayOfWeek] Invalid date parameter', date)
    return
  }
}

const checkIfMinor = (date) => {
  const formStore = useFormStore()
  const dobLxn = DateTime.fromFormat(date, 'dd/MM/yyyy')
  const now = DateTime.now()

  const age = now.diff(dobLxn, 'years').years
  const is16OrBelow = age <= 16

  if (!is16OrBelow) return

  formStore.form.setValues({
    maritalStatusId: 1,
    educationLevelId: 8
  })
}

export default function () {
  return {
    changeAppointmentDate,
    checkPersonInfo: use446Actions().checkPersonInfo,
    checkDateForViolationNumberOfYears,
    getDayOfWeek,
    checkIfMinor
  }
}
